var React = require('react');

function Visa (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Visa Inc logo - Brandlogos.net"),React.createElement("path",{"d":"M551.23,470c-18.41,0-34.86,9.54-34.86,27.17,0,20.22,29.17,21.61,29.17,31.77,0,4.28-4.9,8.1-13.27,8.1a44.07,44.07,0,0,1-20.76-5.35l-3.8,17.79A64.79,64.79,0,0,0,531.53,554c20.13,0,36-10,36-27.94,0-21.36-29.3-22.72-29.3-32.14,0-3.35,4-7,12.37-7a42,42,0,0,1,17.1,3.89l3.72-17.18A55.64,55.64,0,0,0,551.23,470Zm-168.41,1.3-.45,2.59a86.57,86.57,0,0,1,14.72,4.24c9,3.24,9.62,5.13,11.13,11l16.48,63.54H446.8l34-81.37h-22l-21.87,55.32L428,479.73c-.82-5.37-5-8.43-10-8.43Zm106.88,0-17.29,81.37h21l17.23-81.37h-21Zm117.24,0c-5.07,0-7.75,2.71-9.72,7.46l-30.8,73.91h22l4.26-12.32h26.85l2.59,12.32h19.45l-17-81.37H606.94Zm2.87,22,6.53,30.53h-17.5l11-30.53Z","transform":"translate(-382.37 -470)","style":{"fill":"#1434cb"},"key":1})]);
}

Visa.defaultProps = {"width":"259.25","height":"84","viewBox":"0 0 259.25 84"};

module.exports = Visa;

Visa.default = Visa;



// WEBPACK FOOTER //
// ./src/images/icons/visa.svg